import styled from 'styled-components';

export const StyledShareModal = styled.div`
  width: 100%;

  .holder {
    padding: 10px 0 30px;
    font-size: 16px;
    line-height: 22px;
  }

  .socialnetwork {
    list-style: none;
    margin: 0 0 15px;
    padding: 0;
    display: flex;
    justify-content: center;
    gap: 25px;

    li {
      margin: 0 0 10px;
    }

    .icon-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 90px;
      height: 90px;
      margin: 0 0 20px;
      border-radius: 10px;
      background: #f1f1f1;
    }

    .text {
      display: block;
      font-size: 18px;
      line-height: 20px;
      font-weight: 400;
      color: var(--text-color);
    }
  }

  .input-box {
    position: relative;
    max-width: 500px;
    margin: 0 auto;

    .btn-copy {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      font-size: 24px;
      line-height: 1;
      cursor: pointer;
    }

    input {
      width: 100%;
      height: 55px;
      font-size: 16px;
      line-height: 20px;
      padding: 10px 40px 10px 15px;
      border-radius: 10px;
      border: 1px solid rgba(157, 157, 157, 0.6);
      background: #f1f1f1;
    }
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;
